import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentUserData } from '../utils/userUtils';
import { hasPermission } from '../utils/permissions';

export default function RequirePermission({ permission, children, fallback = null }) {
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const ud = await getCurrentUserData();
      if (!mounted) return;
      setAllowed(hasPermission(ud, permission));
    })();
    return () => (mounted = false);
  }, [permission]);

  if (allowed === null) return null; // loading
  if (allowed) return <>{children}</>;
  // If not allowed, redirect to home (or render fallback if provided)
  if (fallback) return <>{fallback}</>;
  return <Navigate to="/" replace />;
}
